/* eslint-disable-next-line */
export interface InlineLoadingSpinnerProps {}

export function InlineLoadingSpinner(props: InlineLoadingSpinnerProps) {
  return (
    <span className="animate-spin text-light-primaryText dark:text-dark-primaryText">
      <i className="fa-solid fa-spinner-third fa-spin" />
    </span>
  );
}

export default InlineLoadingSpinner;
